export const isLoggedIn = ({ isLoggedIn }) => isLoggedIn;
export const isNative = ({ isNative }) => isNative;
export const address = ({ address }) => address;
export const nativeAccount = ({ nativeAccount }) => nativeAccount;
export const provider = ({ provider }) => provider;
